export const fetchTeam = resp => {
  return {
    type: "FETCH_TEAM",
    payload: resp
  };
};
export const resetTeam = () => {
  return {
    type: "RESET_TEAM"
  };
};
export const addUserToTeam = (id, order) => {
  return {
    type: "ADD_USER_TO_TEAM",
    id,
    order
  };
};
export const removeUserFromTeam = id => {
  return {
    type: "REMOVE_USER_FROM_TEAM",
    id
  };
};
export const setUserOrder = (id, order) => {
  return {
    type: "SET_USER_ORDER",
    id,
    order
  };
};
export const setTeam = users => {
  return {
    type: "SET_TEAM",
    users
  };
};
export const saveTeamSettings = resp => {
  return {
    type: "SAVE_TEAM_SETTINGS",
    payload: resp
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/user.js